import moment from 'moment';
import { actionConst } from './new-request.constants';

const oi = JSON.parse(localStorage.getItem('dspxOwnerInfo'));

const defaultState = {
  newRequestModalVisible: false,
  listAddrStreet: [],
  listAddrServiceCompany: [],
  listAddrBuilding: [],
  listAddrFlat: [],
  listService: [],
  listSubservice: [],
  listWorker: [],
  listExecuter: [],
  valueSubservice: undefined,
  valueService: undefined,
  valuePossWarranty: false,
  valuePossInternal: false,
  valueAddrStreet: undefined,
  valueAddrServiceCompany: undefined,
  valueAddrBuilding: undefined,
  valueWorker: undefined,
  valueExecuter: undefined,
  valueAddrFlat: undefined,
  termOfExecution: undefined,
  showPossWarranty: false,
  postRequestID: undefined,
  requestId: undefined,
  ownerInfo: true,
	ownerName: '',
	ownerPhone: '',
  applicants: [],
  record: {},
  stageLife: undefined,
  valueStageLife: undefined,
  oldRequests: {},
  hintsByRequestType: [],
  hintsByServiceCompany: [],
  showHints: false,
  showOldRequests: false,
  address_by_phone: []
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actionConst.SET_OWNER_INFO: {
      return {
        ...state,
        ownerInfo: action.payload,
      };
    }
		case actionConst.SET_OWNER_DATA: {
			return {
				...state,
				ownerName: action.payload[0]??'',
				ownerPhone: action.payload[1]??'',
			}
		}
    case actionConst.SET_APPLICANT + '_FULFILLED': {
			return {
				...state,
        applicants: action.payload?.data?.data || action.payload?.data || action.payload,
			}
		}
    case actionConst.SET_STAGE_LIFE + '_FULFILLED': {
      return {
        ...state,
        stageLife: action.payload.stageAddressLifeCycle ? `${action.payload.stageAddressLifeCycle.description} - ${action.payload.stageAddressLifeCycle.name}` : undefined,
        valueStageLife: action.payload.stageAddressLifeCycle
          ? action.payload.stageAddressLifeCycle.id
          : undefined,
      }
    }
    case actionConst.CLEAR_STAGE_LIFE: {
      return {
        ...state,
        stageLife: undefined,
        valueStageLife: undefined
      }
    }
    case actionConst.SET_OLD_REQUESTS + '_FULFILLED': {
      return {
        ...state,
        oldRequests: action.payload
      }
    }
    case actionConst.CLEAR_OLD_REQUESTS: {
      return {
        ...state,
        oldRequests: {}
      }
    }
    case actionConst.SET_HINTS_BY_REQUEST_TYPE + '_FULFILLED': {
      return {
        ...state,
        hintsByRequestType: action.payload
      }
    }
    case actionConst.CLEAR_HINTS_BY_REQUEST_TYPE: {
      return {
        ...state,
        hintsByRequestType: []
      }
    }
    case actionConst.SET_HINTS_BY_SERVICE_COMPANY + '_FULFILLED': {
      return {
        ...state,
        hintsByServiceCompany: action.payload
      }
    }
    case actionConst.CLEAR_HINTS_BY_SERVICE_COMPANY: {
      return {
        ...state,
        hintsByServiceCompany: []
      }
    }
    case actionConst.SET_SHOW_HINTS_AND_OLD_REQUESTS + '_FULFILLED': {
      return {
        ...state,
        showHints: action.payload.showHints,
        showOldRequests: action.payload.showOldRequests,
      }
    }
    case actionConst.CLEAR_APPLICANT: {
			return {
				...state,
        applicants: [],
			}
		}
    case actionConst.RESET_POSTED_REQUEST: {
      return {
        ...state,
        postRequestID: null,
      };
    }
    case actionConst.POST_REQUEST: {
      return {
        ...state,
        postRequestID: action.payload,
      };
    }
    case actionConst.FETCH_SUBSERVICE_REF: {
      return {
        ...state,
        listSubservice: action.payload.value.data.data || action.payload.value.data,
        ...(!!action.payload?.subService ? {valueSubservice: action.payload?.subService} : {})
      };
    }
    case actionConst.FETCH_APPLY_ADDRESS_BY_PHONE_REF + '_FULFILLED': {
      return {
        ...state,
        address_by_phone: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.FETCH_ADDR_BUILDING_REF + '_FULFILLED': {
      return {
        ...state,
        listAddrBuilding: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.FETCH_ADDR_FLAT_REF + '_FULFILLED': {
      return {
        ...state,
        listAddrFlat: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.SET_SUBSERVICE_VALUE: {
      return {
        ...state,
        valueSubservice: action.payload,
      };
    }
    case actionConst.SET_SERVICE_VALUE: {
      return {
        ...state,
        valueService: action.payload,
      };
    }
    case actionConst.SET_ADDR_BUILDING_VALUE: {
      return {
        ...state,
        valueAddrBuilding: action.payload,
      };
    }
    case actionConst.SET_ADDR_FLAT_VALUE: {
      return {
        ...state,
        valueAddrFlat: action.payload,
      };
    }
    case actionConst.SET_WORKER_VALUE: {
      return {
        ...state,
        valueWorker: action.payload,
      };
    }
    case actionConst.SET_EXECUTER_VALUE: {
      return {
        ...state,
        valueExecuter: action.payload,
      };
    }
    case actionConst.SET_REQUEST_ID: {
      return {
        ...state,
        requestId: action.payload,
      };
    }
    case actionConst.APPLY_ADDR_STREET: {
      return {
        ...state,
        valueAddrStreet: action.payload,
      };
    }
    case actionConst.APPLY_ADDR_SERVICE_COMPANY: {
      return {
        ...state,
        valueAddrServiceCompany: action.payload,
      };
    }
    case actionConst.APPLY_SERVICE: {
      return {
        ...state,
        valueService: action.payload,
      };
    }
    case actionConst.APPLY_POSS_WARRANTY: {
      return { ...state, valuePossWarranty: action.payload };
    }
    case actionConst.SET_SHOW_POSS_WARRANTY: {
      return { ...state, showPossWarranty: action.payload };
    }
    case actionConst.APPLY_POSS_INTERNAL: {
      return { ...state, valuePossInternal: action.payload };
    }
    case actionConst.FETCH_EXECUTER_REF: {
      return {
        ...state,
        listExecuter: action.payload.value.data.data || action.payload.value.data,
         ...(!!action.payload?.valueExecuter ? {valueExecuter: action.payload?.valueExecuter} : {})
      };
    }
    case actionConst.FETCH_WORKER_REF: {
      return {
        ...state,
        listWorker: action.payload.value.data.data || action.payload.value.data,
         ...(!!action.payload?.valueWorker ? {valueWorker: action.payload?.valueWorker} : {})
      };
    }
    case actionConst.FETCH_ADDR_STREET_REF + '_FULFILLED': {
      return {
        ...state,
        listAddrStreet: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.FETCH_ADDR_SERVICE_COMPANY + '_FULFILLED': {
      return {
        ...state,
        listAddrServiceCompany: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.FETCH_SERVICE_REF + '_FULFILLED': {
      return {
        ...state,
        listService: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.OPEN_NEW_REQUEST_MODAL: {
      return {
        ...state,
        record: action.payload,
        newRequestModalVisible: true,
      };
    }
    case actionConst.CLOSE_NEW_REQUEST_MODAL: {
      return {
        ...state,
        newRequestModalVisible: false,
      };
    }
    case actionConst.SET_TERM_OF_EXECUTION: {
      return {
        ...state,
        termOfExecution: action.payload,
      };
    }
    case actionConst.RESET_TERM_OF_EXECUTION: {
      return {
        ...state,
        termOfExecution: undefined,
      };
    }
    case actionConst.RETRIEVE_LAST_STATE: {
			return {
				...state,
				...action.payload
			}
		}
    default:
      return state;
  }
};
